import classNames from "classnames";
import type { FC, ReactNode } from "react";

interface IDashboardCategoryItem {
    id: string;
    onClick?: (event) => void;
    selected?: boolean;
    disabled?: boolean;
    icon?: string;
    className?: string;
    count?: string;
    children?: ReactNode;
}

const DashboardCategoryItem: FC<IDashboardCategoryItem> = ({
    onClick,
    selected,
    icon,
    className,
    children,
    disabled,
    count,
}) => {
    const itemText = count ? `${children} (${count})` : `${children}`;
    return (
        <div
            className={classNames("DropdownItem", className, {
                "DropdownItem--disabled": disabled,
                "DropdownItem--selected": selected,
                categoryChildItem: !icon && children !== "All Categories",
            })}
            onClick={onClick}
        >
            {icon ? <i className={classNames(icon, "DropdownItem-icon")} /> : null}
            {itemText}
            {selected ? <span className="icon icon-checked DropdownItem--selected-check" /> : null}
        </div>
    );
};

DashboardCategoryItem.displayName = "DashboardCategoryItem";

export default DashboardCategoryItem;
